import { FormGroup, H3, Intent, TagInput, TextArea } from '@blueprintjs/core';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { WavelightWorkflowState } from '../../views/workflow/types';
import { useCallback, useMemo } from 'react';
import {
  CELLPHONE,
  OXIMETER_TAGS,
  PRESSURE_GAUGE,
  TAGS,
  loadStudyData,
  resetStudyData,
  setStudyData,
} from '../../views/workflow/reducer';
import {
  WorkflowFooter,
  WorkflowInnerContainer,
} from '../../views/workflow/pages/styles';
import { NextButton } from '../FooterButtons';
import { WorkflowStudy } from '../../types';
import LoadDataButton from '../LoadDataButton';
import ResetDataButton from '../ResetDataButton';
import storage from '../../utils/storage';

const Study = () => {
  const dispatch = useAppDispatch();
  const { data }: WavelightWorkflowState = useAppSelector(
    (state) => state.workflow,
  );

  const onChange = useCallback(
    (partial: Partial<WorkflowStudy>) => {
      dispatch(
        setStudyData({
          ...data.study,
          ...partial,
        }),
      );
    },
    [dispatch, data.study],
  );

  const hasDataInLocalStorage =
    !!storage.get(TAGS) ||
    !!storage.get(CELLPHONE) ||
    !!storage.get(OXIMETER_TAGS) ||
    !!storage.get(PRESSURE_GAUGE);

  const hasDataInState = useMemo(
    () =>
      !!data.study.tags.length ||
      !!data.study.oximeterModel.length ||
      !!data.study.phone.length ||
      !!data.study.pressureGaugeModel.length,
    [data.study],
  );

  const handleReset = useCallback(() => {
    dispatch(resetStudyData());
  }, [dispatch]);

  const handleLoadData = useCallback(() => {
    dispatch(loadStudyData());
  }, [dispatch]);

  return (
    <>
      <WorkflowInnerContainer>
        <H3>1. Dispositivos</H3>
        {hasDataInLocalStorage && !hasDataInState && (
          <LoadDataButton handleLoadData={handleLoadData} />
        )}
        {hasDataInState && <ResetDataButton handleReset={handleReset} />}
        <span>Para inserir mais de uma tag, separe-as com vírgula</span>
        <FormGroup intent={Intent.PRIMARY} label={'Tags'}>
          <TagInput
            fill
            addOnBlur
            values={data.study.tags}
            onChange={(values) => {
              onChange({ tags: values.map((cur) => String(cur)) });
            }}
          />
        </FormGroup>
        <FormGroup intent={Intent.PRIMARY} label={'Aparelho celular'}>
          <TagInput
            fill
            addOnBlur
            values={data.study.phone}
            onChange={(values) => {
              onChange({ phone: values.map((cur) => String(cur)) });
            }}
          />
        </FormGroup>
        <FormGroup intent={Intent.PRIMARY} label={'Oxímetro'}>
          <TagInput
            fill
            addOnBlur
            values={data.study.oximeterModel}
            onChange={(values) => {
              onChange({ oximeterModel: values.map((cur) => String(cur)) });
            }}
          />
        </FormGroup>
        <FormGroup intent={Intent.PRIMARY} label={'Medidor de pressão'}>
          <TagInput
            fill
            addOnBlur
            values={data.study.pressureGaugeModel}
            onChange={(values) => {
              onChange({
                pressureGaugeModel: values.map((cur) => String(cur)),
              });
            }}
          />
        </FormGroup>
        <FormGroup
          intent={Intent.PRIMARY}
          label={'Informações adicionais'}
          labelFor="extra-study-input"
        >
          <TextArea
            fill
            autoResize={false}
            value={data.study.extraDescription}
            onChange={(e) => onChange({ extraDescription: e.target.value })}
            onBlur={(e) => onChange({ extraDescription: e.target.value })}
          />
        </FormGroup>
      </WorkflowInnerContainer>
      <WorkflowFooter>
        <NextButton />
      </WorkflowFooter>
    </>
  );
};

export default Study;
